import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

export default function SignupSuccess() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('session_id')
  const [countdown, setCountdown] = useState(10)

  useEffect(() => {
    if (countdown <= 0) { navigate('/login'); return }
    const t = setTimeout(() => setCountdown(c => c - 1), 1000)
    return () => clearTimeout(t)
  }, [countdown, navigate])

  return (
    <div style={{
      minHeight: '100vh', background: '#0a1628',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: '40px 16px', fontFamily: 'Arial, sans-serif',
    }}>
      <div style={{ textAlign: 'center', maxWidth: 480 }}>
        <div style={{ fontSize: 64, marginBottom: 24 }}>🎉</div>
        <div style={{ fontSize: 32, fontWeight: 700, color: '#c9a84c', marginBottom: 8 }}>You're in!</div>
        <div style={{ color: '#fff', fontSize: 18, fontWeight: 600, marginBottom: 16 }}>
          Your Castellan account is being set up.
        </div>
        <div style={{ color: '#94a3b8', fontSize: 14, marginBottom: 32, lineHeight: 1.6 }}>
          Check your email for login instructions. Your account will be ready within a few minutes.
          {sessionId && (
            <div style={{ marginTop: 12, color: '#475569', fontSize: 12 }}>
              Reference: {sessionId.slice(0, 20)}...
            </div>
          )}
        </div>
        <button
          onClick={() => navigate('/login')}
          style={{
            padding: '12px 32px',
            background: 'linear-gradient(135deg, #c9a84c, #d97706)',
            color: '#0a1628', border: 'none', borderRadius: 8,
            fontWeight: 700, fontSize: 15, cursor: 'pointer',
          }}
        >
          Go to Sign In
        </button>
        <div style={{ color: '#475569', fontSize: 12, marginTop: 16 }}>
          Redirecting automatically in {countdown}s
        </div>
      </div>
    </div>
  )
}
